import { NavLink, useNavigate, useParams } from "react-router";
import { ArrowLeft, RefreshCw } from "lucide-react";
import t from "@/lang/lang";
import { useHtzMicrobialBaseDataShowQuery } from "@/services/backend/htz/inspection/api/microbial-base-data-api";
import { MicrobialBaseDataFields } from "@/services/backend/htz/inspection/components/microbial-base-data-fields";
import { DeleteMicrobialBaseDataDialog } from "@/services/backend/htz/inspection/components/delete-microbial-base-data-dialog";
import { CompanyName } from "@/services/backend/company/components/company-name";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { Button } from "@/shared/components/ui/button";
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import { PersistenceStateUsingContext } from "@/shared/lib/persistence-state/persistence-state-info";
import { PersistenceContextProvider } from "@/shared/lib/persistence-state/provider";

export function MicrobialBaseDataRoute() {
  const { microbialBaseDataId } = useParams();
  const navigate = useNavigate();

  const {
    data: baseData,
    isLoading,
    error,
  } = useHtzMicrobialBaseDataShowQuery({ id: microbialBaseDataId! });

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (isLoading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="flex space-x-4">
            <RefreshCw className="animate-spin" />
            <span>{t("Lade Basisdaten")}</span>
          </CardTitle>
        </CardHeader>
      </Card>
    );
  }

  return (
    <PersistenceContextProvider>
      <Card>
        <CardHeader>
          <CardTitle>
            <NavLink to="./..">
              <Button variant="outline" size="sm" className="m-0 mb-4">
                <ArrowLeft className="mr-2 h-4 w-4" />
                <span>{t("Übersicht")}</span>
              </Button>
            </NavLink>
            <div>{baseData!.label}</div>
          </CardTitle>
          <CardDescription>
            <CompanyName companyId={baseData!.companyId} />
          </CardDescription>
          <CardAction className="flex gap-3">
            <PersistenceStateUsingContext />
            <DeleteMicrobialBaseDataDialog
              baseData={baseData!}
              onDeleted={() => navigate("..")}
            />
          </CardAction>
        </CardHeader>
        <CardContent>
          <MicrobialBaseDataFields id={baseData!.id} />
        </CardContent>
      </Card>
    </PersistenceContextProvider>
  );
}
